import { GuestSearchParams } from '../types/security';

/**
 * Pure function that builds GuestSearchParams from individual search field values.
 * Only includes non-empty values in the params object.
 */
export function buildSearchParams(fields: {
  name?: string;
  passport?: string;
  phone?: string;
  dateOfBirth?: string;
  province?: string;
  city?: string;
  hotelId?: string;
  page?: number;
  limit?: number;
}): GuestSearchParams {
  const params: GuestSearchParams = {};
  if (fields.name && fields.name.trim()) params.name = fields.name.trim();
  if (fields.passport && fields.passport.trim()) params.passport = fields.passport.trim();
  if (fields.phone && fields.phone.trim()) params.phone = fields.phone.trim();
  if (fields.dateOfBirth && fields.dateOfBirth.trim()) params.dateOfBirth = fields.dateOfBirth.trim();
  if (fields.province && fields.province.trim()) params.province = fields.province.trim();
  if (fields.city && fields.city.trim()) params.city = fields.city.trim();
  if (fields.hotelId && fields.hotelId.trim()) params.hotelId = fields.hotelId.trim();
  if (fields.page !== undefined) params.page = fields.page;
  if (fields.limit !== undefined) params.limit = fields.limit;
  return params;
}

export interface GuestRecord {
  first_name: string;
  last_name: string;
  passport_number?: string;
  document_number?: string;
  phone_number?: string;
  date_of_birth?: string;
  [key: string]: any;
}

/**
 * Pure client-side filter function for guest records.
 * Matches ALL specified criteria simultaneously (AND logic).
 * A criterion is "specified" if its value is a non-empty string.
 *
 * - name: matches if first_name OR last_name contains the search term (case-insensitive)
 * - passport: matches if passport_number or document_number contains the search term (case-insensitive)
 * - phone: matches if phone_number contains the search term
 * - dateOfBirth: matches if date_of_birth equals the search term exactly
 */
export function filterGuests(
  guests: GuestRecord[],
  criteria: { name?: string; passport?: string; phone?: string; dateOfBirth?: string }
): GuestRecord[] {
  const name = criteria.name?.trim().toLowerCase() || '';
  const passport = criteria.passport?.trim().toLowerCase() || '';
  const phone = criteria.phone?.trim() || '';
  const dob = criteria.dateOfBirth?.trim() || '';

  return guests.filter(guest => {
    if (name) {
      const fullName = `${guest.first_name || ''} ${guest.last_name || ''}`.toLowerCase();
      if (!fullName.includes(name)) return false;
    }
    if (passport) {
      const doc = (guest.passport_number || guest.document_number || '').toLowerCase();
      if (!doc.includes(passport)) return false;
    }
    if (phone) {
      const guestPhone = (guest.phone_number || '');
      if (!guestPhone.includes(phone)) return false;
    }
    if (dob) {
      if (guest.date_of_birth !== dob) return false;
    }
    return true;
  });
}
